var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmailUnread(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_527_84)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M16 24H56.4C57.28 28.28 59.56 32 62.68 34.84L48 44L16 24ZM16 32V72H80V39.6C78.72 39.88 77.36 40 76 40C73.6 40 71.36 39.52 69.2 38.72L48 52L16 32Z",
    fill: "#2B3E5B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80 39.6C82.96 39 85.68 37.68 88 35.92V72C88 76.4 84.4 80 80 80H16C11.6 80 8 76.4 8 72V24C8 19.6 11.6 16 16 16H56.4C56.16 17.28 56 18.64 56 20C56 21.36 56.16 22.72 56.4 24H16L48 44L62.68 34.84C64.56 36.56 66.76 37.88 69.2 38.76L48 52L16 32V72H80V39.6Z",
    fill: "#2B3E5B"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M77 9C73.265 9 71 11.8857 71 15.4286V24H83V15.4286C83 11.8857 80.735 9 77 9Z",
    fill: "#FFA000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77 30C78.5125 30 79.75 28.8 79.75 27.3333H74.25C74.25 28.8 75.4875 30 77 30ZM85.25 22V15.3333C85.25 11.24 83.0087 7.81333 79.0625 6.90667V6C79.0625 4.89333 78.1412 4 77 4C75.8588 4 74.9375 4.89333 74.9375 6V6.90667C71.005 7.81333 68.75 11.2267 68.75 15.3333V22L66 24.6667V26H88V24.6667L85.25 22ZM82.5 23.3333H71.5V15.3333C71.5 12.0267 73.5763 9.33333 77 9.33333C80.4237 9.33333 82.5 12.0267 82.5 15.3333V23.3333Z",
    fill: "#FFA000"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_527_84"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 96,
    height: 96,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailUnread);
export default __webpack_public_path__ + "static/media/emailUnread.e6a06d3601ee01e27ae6463ad0dd559a.svg";
export { ForwardRef as ReactComponent };